import { render, staticRenderFns } from "./VartextView.vue?vue&type=template&id=df8aec0e&"
import script from "./VartextView.vue?vue&type=script&lang=js&"
export * from "./VartextView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports